import { ArrowLeft, ThumbDownOutlined } from "@mui/icons-material";
import { Loading } from "react-admin";
import { useEffect, useState } from "react";

export default function SingleChoiceMCQ(props) {
  const {
    styles,
    showLoader,
    sidePanel,
    submitAnswer,
    questionContent,
    handleOpenReportModal,
    fetchQuestion,
    showToast,
    isSolved,
    prevUserAnswer,
    moveQuestionIndex,
    currentQuestionIndex,
    latestQuestionIndex,
    remainingXP,
  } = props;
  const { question, options } = questionContent.content;
  const questionBlockId = questionContent.id;

  const [selectedOption, setSelectedOption] = useState(null);
  const [disableOptions, setDisableOptions] = useState(false);
  const [questionPanelLoader, setQuestionPanelLoader] = useState(false);
  const [highlight, setHighlight] = useState(false);
  

  const nextQuestion = async () => {
    try {
      setQuestionPanelLoader(true);
      setDisableOptions(true);
      setSelectedOption(null);
      await fetchQuestion();
    } catch (error) {
      console.error("Error in nextQuestion:", error);
      showToast("An error occurred while fetching the next question.", "error");
    } finally {
      setDisableOptions(false);
      setQuestionPanelLoader(false);
    }
  };

  const handleOptionSelection = async (option) => {
    try {
      setDisableOptions(true);
      setSelectedOption(option);
      await submitAnswer(option);
    } catch (error) {
      console.error("Error in handleOptionSelection:", error);
      showToast("An error occurred while Submitting your answer.", "error");
    } finally {
      setDisableOptions(false);
    }
  };

  const moveIndex = async (direction) => {
    try {
      setDisableOptions(true);
      setSelectedOption(null);
      await moveQuestionIndex(direction);
    } catch (error) {
      console.error("Error in moveIndex:", error);
      showToast(
        "An error occurred while moving to the next question.",
        "error"
      );
    } finally {
      setDisableOptions(false);
    }
  };

  useEffect(() => {
    if (isSolved || selectedOption === null) {
      setSelectedOption(prevUserAnswer);
    }
    setDisableOptions(isSolved);
  }, [isSolved, currentQuestionIndex]);

  useEffect(() => {
    if (remainingXP < 10 && !showLoader) {
      setHighlight(true);
      setTimeout(() => {
        setHighlight(false);
      }, 800);
    }
  }, [showLoader]);

  return (
    <div className={styles.question_option_panel}>
      <div
        className={`${styles.question_panel} ${
          !sidePanel && styles.side_panel_close
        }`}
      >
        <div className={styles.header}>
          <span className={styles.title}>
            Question <span className={`${highlight && styles.flash}`}>({remainingXP} XP)</span>
          </span>
          <div className={styles.actions}>
            <ArrowLeft
              className={`${styles.action_btn} ${
                currentQuestionIndex === 0 && styles.disable
              }`}
              onClick={async () => {
                await moveIndex(-1);
              }}
            />
            <span className={styles.question_index}>
              {currentQuestionIndex + 1}
            </span>
            <ArrowLeft
              className={`${styles.action_btn} ${styles.left} ${
                latestQuestionIndex - currentQuestionIndex <= 0 &&
                styles.disable
              }`}
              onClick={async () => {
                await moveIndex(1);
              }}
            />
          </div>
        </div>

        {questionPanelLoader ? (
          <Loading
            loadingPrimary=""
            loadingSecondary="Generating Question..."
          />
        ) : (
          <div className={styles.question}>
            {question?.length > 0 ? (
              <>
                <div className={styles.question_wrapper}>
                  {question}
                  <button
                    title="Report"
                    onClick={() => {
                      handleOpenReportModal({
                        reportFor: "QUESTION",
                        blockId: questionBlockId || null,
                        index: currentQuestionIndex,
                      });
                    }}
                  >
                    <ThumbDownOutlined className={styles.icon} />
                  </button>
                </div>
                {isSolved && currentQuestionIndex === latestQuestionIndex && (
                  <div
                    className={styles.btn}
                    onClick={async () => await nextQuestion()}
                  >
                    Next Question
                  </div>
                )}
              </>
            ) : (
              "Failed to open this page. Please try again."
            )}
          </div>
        )}
      </div>

      {!questionPanelLoader && (
        <div className={styles.option_panel}>
          {options?.length > 0 &&
            options.map((item, index) => (
              <label
                key={item}
                className={`${styles.option} ${
                  selectedOption === index && styles.selected
                } ${!showLoader && isSolved && styles.correct} ${
                  !showLoader && !isSolved && styles.incorrect
                }`}
              >
                <input
                  className={styles.hidden_input}
                  type="radio"
                  name="mcq"
                  value={item}
                  checked={selectedOption === index}
                  onChange={() => handleOptionSelection(index)}
                  disabled={disableOptions}
                />
                {item}
              </label>
            ))}
        </div>
      )}
    </div>
  );
}
